import { ReactNode } from 'react';

import { UserIcon } from '@/assets/icons/user';
import { Row } from '@/components/lib/components';
import { Box } from '@/components/lib/components/Box';
import { ds } from '@/components/lib/design.system';
import { RaceToPlaceEntry } from '@/types/socialFeed.generated';

import { FillMeter } from './FillMeter';
import { MultiplierTag } from './MultiplierTag';
import { RACE_TO_PLACE_FILL_METER_HEIGHT } from './race-to-place-constants';

type RaceToPlaceCardProps = {
    raceToPlaceEntry: RaceToPlaceEntry;
    fillMeterContainerWidth: number | undefined;
    list: ReactNode;
    action: ReactNode;
};

export const RaceToPlaceCard = ({ raceToPlaceEntry, fillMeterContainerWidth, list, action }: RaceToPlaceCardProps) => (
    <Box borderRadius={'r20'} paddingBottom={'s16'}>
        <MultiplierTag oldMultiplier={raceToPlaceEntry.multiplier} newMultiplier={raceToPlaceEntry.boostedMultiplier} />
        {list}
        <Row
            px={'s16'}
            pb={'s16'}
            height={RACE_TO_PLACE_FILL_METER_HEIGHT}
            position={'relative'}
            width={fillMeterContainerWidth}
        >
            <FillMeter
                current={raceToPlaceEntry.occupiedSlots}
                total={raceToPlaceEntry.size}
                icon={<UserIcon width={20} height={20} fill={ds.colorValue.icon.secondary} />}
            />
        </Row>
        {action}
    </Box>
);
